import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import AnimatedBackground from "../components/AnimatedBackground";
import "../App.css";

const Contact = () => {
  return (
    <>
      <AnimatedBackground />
      <div className="app">
        <div className="top-header">
          <div className="navbar-wrap">
            <Navbar />
          </div>
        </div>

        <main className="main-content">
          <section className="section">
            <div className="section-inner">
              <div className="contact-card reveal-on-scroll is-visible">
                <div className="contact-header">
                  <h2 className="section-heading text-uppercase">Contact Us</h2>
                  <div className="contact-details">
                    <div className="contact-detail">
                      <span className="contact-icon">📞</span>
                      <span>+1 (302) 400-5801</span>
                    </div>
                    <div className="contact-detail">
                      <span className="contact-icon">✉️</span>
                      <a href="mailto:info@consumergenie.net">info@consumergenie.net</a>
                    </div>
                  </div>
                </div>

                <form
                  action="https://formspree.io/f/mwporzwb"
                  method="POST"
                  className="contact-form"
                >
                  <div className="contact-form-intro">
                    <h3>Contact Us</h3>
                    <p>We’d love to hear from you!</p>
                  </div>

                  <div className="contact-row">
                    <div className="contact-column">
                      <label htmlFor="name">Name</label>
                      <input
                        type="text"
                        className="contact-input"
                        name="name"
                        id="name"
                        placeholder="Your Name"
                        required
                      />

                      <label htmlFor="email">Email</label>
                      <input
                        type="email"
                        className="contact-input"
                        name="email"
                        id="email"
                        placeholder="Your Email"
                        required
                      />

                      <label htmlFor="phone">Phone</label>
                      <input
                        type="tel"
                        className="contact-input"
                        name="phone"
                        id="phone"
                        placeholder="Your Phone (optional)"
                      />
                    </div>

                    <div className="contact-column">
                      <label htmlFor="message">Message</label>
                      <textarea
                        className="contact-textarea"
                        name="message"
                        id="message"
                        rows={8}
                        placeholder="Type your message here..."
                        required
                      />
                    </div>
                  </div>

                  <button type="submit" className="contact-button">
                    Send Message
                  </button>
                </form>
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
};

export default Contact;
